import { useMemo } from 'react';
import { DecimalService } from '@mews/framework';
import {
    CommonProcessPaymentFormModel,
    ProcessPaymentFormField,
} from '../components/forms/ProcessPayment/ProcessPaymentFormSchema';
import { useGetPayableInvoicesSuspense } from '../components/InvoiceAsyncSelect/queries';
import { useConvertAmountToCurrencySuspense } from './useConvertAmountToCurrencySuspense';

interface GetTotalOfSelectedInvoicesProps {
    selectedInvoiceIds: CommonProcessPaymentFormModel[ProcessPaymentFormField.InvoiceIds];
    currencyCode: CommonProcessPaymentFormModel[ProcessPaymentFormField.CurrencyCode];
    accountId: string;
    ownerIds?: string[];
}

export const useGetTotalOfSelectedInvoicesSuspense = ({
    selectedInvoiceIds,
    currencyCode,
    accountId,
    ownerIds,
}: GetTotalOfSelectedInvoicesProps) => {
    const convertAmountToCurrency = useConvertAmountToCurrencySuspense();
    const hasMultipleOwners = ownerIds && ownerIds?.length > 1;
    const {
        data: { invoices },
    } = useGetPayableInvoicesSuspense({ ownerIds: hasMultipleOwners ? ownerIds : [accountId] });

    return useMemo(() => {
        if (!selectedInvoiceIds) {
            return null;
        }

        const totalFromInvoices = selectedInvoiceIds
            .map((invoiceId) => (invoices || []).find(({ id }) => invoiceId === id))
            .reduce(
                (total, invoice) =>
                    total + (invoice ? convertAmountToCurrency(invoice?.balance.value || 0, currencyCode) || 0 : 0),
                0
            );

        return DecimalService.toNumber(DecimalService.round(DecimalService.parse(totalFromInvoices), 2));
    }, [selectedInvoiceIds, invoices, convertAmountToCurrency, currencyCode]);
};
